import {SetGetProviderList} from './thunk/setGetProviderList';
import {SetGetSearchList} from './thunk/setGetSearchList';
import {SetPostUpdateStatus} from './thunk/setPostUpdateStatus';

export const Thunks = {
    SetGetProviderList,
    SetGetSearchList,
    SetPostUpdateStatus
}